import { DEFAULT_DURATION_EACH_PLAYER_MINUTES, MIN_DURATION_EACH_PLAYER_MINUTES } from '../config/config';
import { IS_LOCAL } from '../config/env';


export const prepAppState = (initialState) => {
  const newAppData = { ...initialState };
  let maxTimeParam;
  
  if (window.location.search) {
    console.log('URL PARAMS app state:', window.location.search);
    // Parse URL parameters to get player names and timer duration - if any
    const params = new URLSearchParams(window.location.search);
    // Change Default Timer
    maxTimeParam = parseInt(params.get('time') || params.get('timer'));
    // Invite Link
    const player1Param = params.get('player1');
    const player2Param = params.get('player2');  
    if (player1Param && player2Param && player1Param !== player2Param) {
      newAppData.isInviteMatch = true;
      newAppData.players = { player1: player1Param, player2: player2Param };
    }
  }
  
  // Match Duration (seconds)
  newAppData.maxTime = Math.max(
    MIN_DURATION_EACH_PLAYER_MINUTES,
    (maxTimeParam || DEFAULT_DURATION_EACH_PLAYER_MINUTES),
  ) * 60;
  
  IS_LOCAL && console.log('Init state app:', newAppData);
  return newAppData;
};
